import BackendQuery from "decentralized/BackendQuery.js";
import {sleep} from "utils/sleep.js";
import ipfs from "decentralized/Ipfs.js"
import {IPFS_HASH} from "decentralized/EthereumDataTypes.js";
import {
    SampleCreated,
    TokenizedSequenceEdited,
    ReleaseInfo,
    NewDiscogsSample,
    NewPreset2,
    NewWallpaper,
    NewEffect
} from '../EthereumEvents.js';
import GuildSamplesContract from "decentralized/contracts/GuildSamplesContract.js";
import TokenizedSequencesContract from "decentralized/contracts/TokenizedSequencesContract.js";
import GuildPresetsContract from "decentralized/contracts/GuildPresetsContract.js";
import ArtistsContract from "decentralized/contracts/ArtistsContract.js";
import WallpaperContract from "decentralized/contracts/WallpaperContract.js";
import EffectsContract from "decentralized/contracts/EffectsContract.js";

const CONCURRENT_SIZE = 12;

export const EVENTS = [
    {
        events: [SampleCreated, NewDiscogsSample],
        contract:  new GuildSamplesContract().contractAddress
    },
    {
        events: [TokenizedSequenceEdited],
        contract: new TokenizedSequencesContract().contractAddress
    },
    {
        events: [NewPreset2],
        contract: new GuildPresetsContract().contractAddress
    },
    {
        events: [NewWallpaper],
        contract: new WallpaperContract().contractAddress
    },
    {
        events: [ReleaseInfo],
        contract: new ArtistsContract().contractAddress
    },
    {
        events: [NewEffect],
        contract: new EffectsContract().contractAddress
    }
];

/**
 * returns all the hashes we need to download
 */
export const getAllHashes = async () => {
    let hashes = [];

    for (let e of EVENTS) {
        hashes = [
            ... hashes,
            ... await getContractHashes(e)];
    }

    let pinned = new Set(await ipfs.getPinnedHashes());
    let l = hashes
        .map(x => x)
        .filter(
        x => !pinned.has(x));
    l.reverse();
    return l;
};

const getContractHashes = async ({contract, events}) => {
    let hashes = [];
    for (let event of events) {
        // find topic that is IPFS_HASH event.topics
        let topic = [...event.topics, ...event.data]
            .find(t => t.type === IPFS_HASH);
        let query = new BackendQuery(contract)
            .from(event)
            .select(topic.name);
        let results = await query.executeQuery();
        hashes = [... hashes, ... results.map(x => x[topic.name])];
    }
    return hashes
        .filter(x => x && x !== "0");
};

export const pinAll = (hashes) => {
    let pinned = new Set();
    let pinning = new Set();

    const pin = async () => {
        
        let i=0;
        for (let hash of hashes) {
            if (hash === "0" || hash === 0) {
                continue;
            } 
            console.log('pinning \"' + hash+"\ type=", typeof hash);
            pinning.add(hash);
            ipfs.pin(hash).then(
                x => {
                    console.log('successfully pinned hash=', hash);
                    pinned.add(hash);
                    pinning.delete(hash);
                });
            // wait till everything has pinned
            while (pinning.size > CONCURRENT_SIZE) {
                await sleep(100);
            }
        }
    };

    pin();
    return () => ({
        pinned:pinned.size,
        pinning: pinning.size,
        progress: 100.0 * (pinned.size) / hashes.length
    });
};

